import { all, call, put, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import MarketplaceHttpService from '../../services/marketplace.http';

export function* GET({ payload }) {
  yield put({
    type: actions.marketplace.SET_STATE,
    payload: { loading: true }
  });

  const response = yield call(MarketplaceHttpService.get, payload);

  if (response) {
    if (response.status < 400) {
      yield put({
        type: actions.marketplace.SET_STATE,
        payload: {
          ...response.data
        }
      });
    } else {
      yield put({
        type: actions.notification.SET_STATE,
        payload: {
          open: true,
          severity: 'error',
          message: response.data.message
        }
      });
    }
  }

  yield put({
    type: actions.marketplace.SET_STATE,
    payload: {
      loading: false
    }
  });
}

export default function* rootSaga() {
  yield all([takeEvery(actions.marketplace.GET, GET)]);
}
